'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const PersonStatisticsViewModel=require('../../../dist-es6/client/viewModels/personStatisticsViewModel');let

FatigueTrendsPersonViewModel=function(_PersonStatisticsView){_inherits(FatigueTrendsPersonViewModel,_PersonStatisticsView);
function FatigueTrendsPersonViewModel(){_classCallCheck(this,FatigueTrendsPersonViewModel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key]}return _possibleConstructorReturn(this,
_PersonStatisticsView.call.apply(_PersonStatisticsView,[this].concat(args)));
}_createClass(FatigueTrendsPersonViewModel,[{key:'averageFatigueOnDuty',get:function()

{
return this._statistics.averageFatigueOnDuty;
}},{key:'averageHoursOfSleepPerDay',get:function()

{
return this._statistics.averageHoursOfSleepPerDay;
}},{key:'maxFatigueOnDuty',get:function()

{
return this._statistics.maxFatigueOnDuty;
}},{key:'hasDuties',get:function()

{
return this._statistics.numDuties>0;
}},{key:'numDuties',get:function()

{
return this._statistics.numDuties;
}},{key:'dutyHours',get:function()

{
return this._statistics.dutyHours;
}},{key:'numTripsOnDuty',get:function()

{
return this._statistics.numTripsOnDuty;
}},{key:'fatigueDistribution',get:function()

{
return this._statistics.fatigueDistribution;
}}]);return FatigueTrendsPersonViewModel}(PersonStatisticsViewModel);


module.exports=FatigueTrendsPersonViewModel;
//# sourceMappingURL=fatigueTrendsPersonViewModel.js.map
